import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { ILicensesInfo } from "src/Utils/Hooks/ManageLicenses/useGetLicensesInfo";
import { useCancelSubscription } from "src/Utils/Hooks/Payments/useCancelSubscription";
import SubscriptionCancelDialog from "./SubscriptionCancelDialog/SubscriptionCancelDialog";
import SubscriptionCancelledDialog from "./SubscriptionCancelledDialog/SubscriptionCancelledDialog";

interface ICancelSubscription {
    clinicId: string;
    setInfo: (message: string, type: InfoMessageType) => void;
    updatePageLoader: (load: boolean) => void;
    licensesInfo: ILicensesInfo;
    clinicName: string;
}

const CancelSubscription: React.FC<ICancelSubscription> = ({ clinicId, setInfo, updatePageLoader, licensesInfo, clinicName }) => {
    const { t } = useTranslation();
    const [showCancelDialog, setShowCancelDialog] = useState<boolean>(false);
    const [showCancelledDialog, setShowCancelledDialog] = useState<boolean>(false);
    const { reqestResponse, reqestError, reqestLoading, cancelSubscription } = useCancelSubscription();

    const handleCancel = useCallback(() => {
        cancelSubscription(clinicId);
    }, [clinicId, cancelSubscription])

    useEffect(() => {
        if (reqestError !== '') {
            setInfo(`Failed to cancel subscription for clinic ${clinicName}`, InfoMessageType.error);
            setShowCancelDialog(false);
        }
    }, [reqestError, setInfo, clinicName]);

    useEffect(() => {
        if (reqestResponse) { 
            setShowCancelDialog(false);
            setShowCancelledDialog(true);
        }
    }, [reqestResponse, setInfo]);

    useEffect(() => {
        updatePageLoader(reqestLoading);
    }, [reqestLoading, updatePageLoader]);

    const handleCancelledDialogClose = () => {
        setShowCancelledDialog(false);
        setInfo('License subscription cancelled successfully.', InfoMessageType.success);
    }

    return(
        <>
            {   showCancelDialog && 
                <SubscriptionCancelDialog
                    onClose={() => { setShowCancelDialog(false); }}
                    onCancel={handleCancel}
                    licenseEndDate={licensesInfo?.clinicUserAndStorageLicenseInfo?.licenseEndDate}
                />
            }
            {
                showCancelledDialog && 
                <SubscriptionCancelledDialog
                    onClose={handleCancelledDialogClose}
                    licenseEndDate={licensesInfo?.clinicUserAndStorageLicenseInfo?.licenseEndDate}/>
            }
            <div onClick={() => setShowCancelDialog(true)} className="dropdown-item" id="cancel-subscription">
                {t('CancelSubscription')}
            </div>
        </>
    )
}

export default CancelSubscription;